// import React from 'react'
// import ReactDOM from 'react-dom/client'
// import App from './App.tsx'
// import './index.css'

// ReactDOM.createRoot(document.getElementById('root')!).render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
// )

// import App from "./App.tsx";

import { memo, Suspense, useCallback, useEffect } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import * as Tooltip from "@radix-ui/react-tooltip";
import { HelmetProvider } from "react-helmet-async";
import { pdfjs } from "react-pdf";
import { useShallow } from "zustand/react/shallow";

import { axiosClient, queryClient } from "@api/clients.ts";
import { AppRouter } from "@routes/appRouter.tsx";
import { SkeletonContainer } from "@components/atoms/loader";
import { TOAST_CONTAINER_PROPS } from "@configs";
import { useErrorHandler } from "@api/errorHandler/apiErrorHandler";
import { useAxiosErrorStore } from "@/stores/axiosErrorStore";
import { HeadConfig } from "@/headConfig";

import "@api/apiPath/util";
import "@/styles/main.css";
import "react-toastify/dist/ReactToastify.css";
import "./assets/flags/flag-icons-min.css";
import "./assets/flags/flag-icons.css";
import "./i18n/i18n";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export const MainRoot = memo(function Main() {
  const { i18n } = useTranslation();
  // useSocket();
  const setError = useAxiosErrorStore(useShallow((state) => state.setError));

  const setErrorFunc = useCallback(
    (message: string, status: number) => {
      setError({ message, status });
    },
    [setError],
  );
  const errorHandler = useErrorHandler(setErrorFunc);

  useEffect(() => {
    axiosClient.interceptors.response.use(undefined, errorHandler);
  }, [errorHandler]);

  return (
    <HelmetProvider>
      <HeadConfig />
      <Tooltip.Provider delayDuration={0}>
        <QueryClientProvider client={queryClient}>
          <SkeletonContainer>
            <Suspense>
              <AppRouter />
            </Suspense>
          </SkeletonContainer>
          <div dir={"ltr"}>
            <ReactQueryDevtools initialIsOpen={false} />
          </div>
          <ToastContainer
            {...TOAST_CONTAINER_PROPS}
            rtl={i18n.dir() === "rtl"}
          />
        </QueryClientProvider>
      </Tooltip.Provider>
    </HelmetProvider>
  );
});
